export default "__VITE_ASSET__36d230dc__"